module.exports = __webpack_public_path__ + "604720642a950261e45e95a99840ed3e.fbx";